/* @flow */

export async function MeetingPackageListApp() {
  return (await import('packages/show')).MeetingPackageListApp;
}

export async function CelebrationPackageListApp() {
  return (await import('packages/show')).CelebrationPackageListApp;
}

export async function ExperiencePackageListApp() {
  return (await import('packages/show')).ExperiencePackageListApp;
}

export async function VenuePackageListApp() {
  return (await import('packages/show')).VenuePackageListApp;
}

export async function VenueDescriptionFieldRoot() {
  return (await import('venues/components/VenueDescriptionFieldRoot')).default;
}

export async function InquiryFormFields() {
  return (await import('inquiry/components/InquiryFormFields')).default;
}

export async function AvailabilitySourceForm() {
  return (await import('reservations/components/AvailabilitySourceForm'))
    .default;
}

export async function EventConsultationRoot() {
  return (await import('eventConsultations')).default;
}

export async function PhoneNumberForm() {
  return (await import('phoneNumbers/components/PhoneNumberForm')).default;
}

export async function ViewPhoneNumberButton() {
  return (await import('phoneNumbers/components/ViewPhoneNumberButton.rails'))
    .default;
}

export async function SiblingGroupPreviewApp() {
  return (await import('groups/venues/show/components/SiblingGroupPreviewApp'))
    .default;
}

export async function Rating() {
  return (await import('common/components/Rating')).default;
}

export async function RatingBoxAccordion() {
  return (await import('common/components/accordion/RatingBoxAccordion'))
    .default;
}

export async function VenueInfoBoxAccordion() {
  return (await import('common/components/accordion/VenueInfoBoxAccordion'))
    .default;
}

export async function CommissionRoot() {
  return (await import('commission/components/CommissionRoot')).default;
}

export async function PackageEditorRoot() {
  return (await import('packages/edit')).default;
}

export async function ConversationRoot() {
  return (await import('conversations/show/components/ConversationRoot.rails'))
    .default;
}

export async function MarkAsRepliedRoot() {
  return (await import('conversations/show/components/MarkAsRepliedRoot.rails'))
    .default;
}

export async function VenueGroupEditorApp() {
  return (await import('groups/venues/edit')).default;
}

export async function TranslatedVenueDescription() {
  return (await import('venues/components/TranslatedVenueDescription')).default;
}

export async function SendCopy() {
  return (await import('thanks/components/SendCopy')).default;
}

export async function MessageTemplateEditorApp() {
  return (await import('messageTemplates/components/MessageTemplateEditorApp.rails'))
    .default;
}

export async function MultiSelect() {
  return (await import('common/components/MultiSelect.rails')).default;
}

export async function VenuePageInquiryForm() {
  return (await import('inquiry/components/VenuePageInquiryForm.rails'))
    .default;
}

export async function SearchableInquiryIndex() {
  return (await import('conversations/index/components/SearchableInquiryIndex.rails'))
    .default;
}

export async function InvoicingFields() {
  return (await import('admin/invoicingFields/components/InvoicingFields.rails'))
    .default;
}
